export default "__VITE_PUBLIC_ASSET__2929fb15__"